<template>
    <div class="error-404-container">
        <div class="error-content">
            <!-- Анимированная 404 -->
            <div class="error-number">
                <span class="digit digit-4-1">4</span>
                <span class="digit digit-0">
                    <div class="zero-animation">
                        <div class="circle"></div>
                        <div class="car-icon">
                            <v-icon x-large color="white">mdi-car-side</v-icon>
                        </div>
                    </div>
                </span>
                <span class="digit digit-4-2">4</span>
            </div>

            <!-- Текст ошибки -->
            <h1 class="error-title">{{ $t('errors.page_not_found_title') }}</h1>
            <p class="error-description">{{ $t('errors.page_not_found_text') }}</p>

            <!-- Кнопки действий -->
            <div class="error-actions pt-4">
                <v-btn 
                    x-large 
                    color="primary" 
                    rounded 
                    elevation="2"
                    @click="goHome"
                    class="action-button"
                >
                    <v-icon left>mdi-home</v-icon>
                    {{ $t('custom.go_to_home') }}
                </v-btn>
                <v-btn 
                    x-large 
                    outlined 
                    color="primary" 
                    rounded
                    @click="goBack"
                    class="action-button ml-4"
                >
                    <v-icon left>mdi-arrow-left</v-icon>
                    {{ $t('custom.go_back') }}
                </v-btn>
            </div>

            <!-- Декоративные элементы -->
            <div class="floating-elements">
                <div class="floating-icon" v-for="n in 6" :key="n" :style="getFloatingStyle(n)">
                    <v-icon :color="getIconColor(n)">{{ getIcon(n) }}</v-icon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Http404',
    methods: {
        goHome() {
            this.$router.push({ path: '/dashboard' });
        },
        goBack() {
            this.$router.go(-1);
        },
        getFloatingStyle(index) {
            const positions = [
                { top: '10%', left: '10%', animationDelay: '0s' },
                { top: '20%', right: '15%', animationDelay: '0.5s' },
                { top: '60%', left: '8%', animationDelay: '1s' },
                { top: '70%', right: '20%', animationDelay: '1.5s' },
                { top: '40%', left: '5%', animationDelay: '2s' },
                { top: '80%', right: '10%', animationDelay: '2.5s' }
            ];
            return positions[index - 1];
        },
        getIcon(index) {
            const icons = ['mdi-car', 'mdi-key', 'mdi-calendar-check', 'mdi-account', 'mdi-cash', 'mdi-wrench'];
            return icons[index - 1];
        },
        getIconColor(index) {
            const colors = ['primary', 'success', 'warning', 'error', 'info', 'purple'];
            return colors[index - 1];
        }
    }
}
</script>

<style scoped>
.error-404-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    position: relative;
    overflow: hidden;
    padding: 20px;
}

.error-404-container::before {
    content: '';
    position: absolute;
    width: 300%;
    height: 300%;
    background: repeating-linear-gradient(
        45deg,
        transparent,
        transparent 35px,
        rgba(255, 255, 255, 0.03) 35px,
        rgba(255, 255, 255, 0.03) 70px
    );
    animation: slide 20s linear infinite;
}

@keyframes slide {
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(-50%, -50%, 0); }
}

.error-content {
    position: relative;
    z-index: 2;
    text-align: center;
    background: rgba(255, 255, 255, 0.95);
    padding: 60px 40px;
    border-radius: 30px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 800px;
    width: 100%;
    backdrop-filter: blur(10px);
}

.error-number {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 30px;
}

.digit {
    font-size: 150px;
    font-weight: 900;
    color: #667eea;
    text-shadow: 4px 4px 0px rgba(102, 126, 234, 0.2);
    animation: bounce 2s ease-in-out infinite;
}

.digit-4-1 {
    animation-delay: 0s;
}

.digit-0 {
    font-size: 0;
}

.digit-4-2 {
    animation-delay: 0.2s;
}

@keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-20px); }
}

.zero-animation {
    width: 150px;
    height: 150px;
    position: relative;
    display: inline-block;
}

.circle {
    width: 150px;
    height: 150px;
    border: 15px solid #667eea;
    border-radius: 50%;
    animation: rotate 3s linear infinite;
    box-shadow: 0 0 20px rgba(102, 126, 234, 0.5);
}

@keyframes rotate {
    0% { transform: rotate(0deg) scale(1); }
    50% { transform: rotate(180deg) scale(1.1); }
    100% { transform: rotate(360deg) scale(1); }
}

.car-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: drive 2s ease-in-out infinite;
}

@keyframes drive {
    0%, 100% { transform: translate(-50%, -50%) translateX(0); }
    50% { transform: translate(-50%, -50%) translateX(10px); }
}

.car-icon .v-icon {
    color: #667eea !important;
    font-size: 60px !important;
}

.error-title {
    font-size: 42px;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 16px;
    animation: fadeInUp 0.8s ease-out;
}

.error-description {
    font-size: 18px;
    color: #718096;
    margin-bottom: 40px;
    line-height: 1.6;
    animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.error-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    flex-wrap: wrap;
    animation: fadeInUp 1.2s ease-out;
}

.action-button {
    transition: all 0.3s ease !important;
}

.action-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2) !important;
}

.floating-elements {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
}

.floating-icon {
    position: absolute;
    animation: float 4s ease-in-out infinite;
    opacity: 0.3;
}

@keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
}

/* Адаптивность для планшетов */
@media (max-width: 768px) {
    .error-content {
        padding: 40px 30px;
        border-radius: 20px;
    }

    .digit {
        font-size: 100px;
    }

    .zero-animation,
    .circle {
        width: 100px;
        height: 100px;
    }

    .circle {
        border-width: 10px;
    }

    .car-icon .v-icon {
        font-size: 40px !important;
    }

    .error-title {
        font-size: 32px;
    }

    .error-description {
        font-size: 16px;
    }

    .error-actions {
        flex-direction: column;
        align-items: stretch;
    }

    .action-button {
        width: 100%;
        margin: 0 0 10px 0 !important;
    }

    .floating-icon {
        display: none;
    }
}

/* Адаптивность для мобильных устройств */
@media (max-width: 480px) {
    .error-404-container {
        padding: 15px;
    }

    .error-content {
        padding: 30px 20px;
        border-radius: 15px;
    }

    .error-number {
        gap: 10px;
        margin-bottom: 20px;
    }

    .digit {
        font-size: 70px;
        text-shadow: 2px 2px 0px rgba(102, 126, 234, 0.2);
    }

    .zero-animation,
    .circle {
        width: 70px;
        height: 70px;
    }

    .circle {
        border-width: 8px;
    }

    .car-icon .v-icon {
        font-size: 30px !important;
    }

    .error-title {
        font-size: 24px;
        margin-bottom: 12px;
    }

    .error-description {
        font-size: 14px;
        margin-bottom: 30px;
    }

    .action-button {
        font-size: 14px !important;
    }
}

/* Темная тема */
.theme--dark .error-content {
    background: rgba(30, 30, 30, 0.95);
}

.theme--dark .error-title {
    color: #e2e8f0;
}

.theme--dark .error-description {
    color: #a0aec0;
}
</style>
